import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import useForm from "../../../hooks/useForm";
import * as AuthActions from "../../../store/auth/actions";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function ForgetPassword() {
  const dispatch = useDispatch();
  const { forgotPasswordSuccess, forgotPasswordFailure, errorMessage } =
    useSelector((state) => state.auth);
  const [isError, setIsError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false)
  const {lang} = useSelector(state =>state.main)

  const handleSubmit = (values) => {
    setIsError("");
    dispatch(
      AuthActions.forgotPasswordCta({
        username: values.email,
      })
    );
  };

  const Form = useForm({
    initialValues: {
      email: "",
    },
    validate: (values) => {
      const errors = {};
      const emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!values.email.trim() || !emailValidate.test(values.email)) {
        errors.email = "Invalid email, please enter a valid email";
      }
      if (isError && errors.email) {
        setIsError("");
      }
      return errors;
    },
    validateOnChange: true,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (forgotPasswordSuccess) {
      Form.setSubmitting();
      setIsError("");
      setIsSuccess(pre => pre ? "Email Resent !" : "Email Sent!")
      dispatch(AuthActions.forgotPasswordCtaInit());
    }

    if (forgotPasswordFailure) {
      setTimeout(() => {
        setIsError(errorMessage);
        dispatch(AuthActions.forgotPasswordCtaInit());
        Form.setSubmitting();
      }, 1000);
    }
  }, [forgotPasswordFailure, forgotPasswordSuccess]);

  return (
    <main className="forgot-password">
      <div className="card">
        {/* logo */}
        <div className="logo-container">
          <Link to="/">
            <img src="/static/images/svg/logo.svg" alt="logo" />
          </Link>
        </div>

        <h1 className="heading">Enter your email to get password reset link</h1>

        {/* login form */}
        <form onSubmit={Form.handleSubmit} autoComplete="off">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="name@domian.com"
              disabled={Form.isSubmitting}
              id="email"
              value={Form.values.email}
              onChange={Form.handleChange}
            />
            {Form.errors.email && (
              <div id="helperText" className="form-text">
                {Form.errors.email}
              </div>
            )}

            {isError && (
              <div id="helperText" className="form-text">
                {isError}
              </div>
            )}

            <div className="form-text">
              Didn’t receive the link ?{" "}
              <button
                type="button"
                onClick={Form.handleSubmit}
                disabled={Form.isSubmitting}
                id="helperText"
                className="btn btn-link"
              >
              Resend
              </button>
            </div>
          </div>

          {Form.isSubmitting && (
            <Spinner
              variant="primary"
              animation="border"
              style={{ alignSelf: "center" }}
            />
          )} 
          
          {( !Form.isSubmitting && 
            <div className="form-group form-text text-center">
              {isSuccess ? <p>{isSuccess}</p> : (
                <button
                disabled={Form.isSubmitting}
                className="btn-contained"
                type="submit"
              >
              Reset Password
              </button>
              )}
              <Link to={"/sign-in"}>Go back to login</Link>
            </div>
          )}
        </form>
      </div>
    </main>
  );
}
